document.addEventListener("turbolinks:load", () => {
  const input = document.querySelector("[data-input='search']")

  input.addEventListener("ajax:success", (event) => {
    const [data] = event.detail
    const json = JSON.parse(data)
    const list = document.getElementById("search-list")
    list.innerHTML = json.content
  })
})
